// icons
import { MdAdminPanelSettings, MdEvent, MdPeople, MdAssessment, MdFavorite, MdLocalHospital, MdVolunteerActivism, MdList, MdCalendarToday, MdPersonAdd, MdDescription, MdArticle, MdHandshake } from "react-icons/md";

const admin = {
    id: 'admin-group',
    type: 'group',
    roles: [1,100],
    breadcrumbs: false,
    children: [
      {
        id: 'admin',
        title: "Administración",
        type: 'collapse',
        icon: MdAdminPanelSettings,
        children: [
          {
            id: 'eventos',
            title: "Eventos",
            type: 'item',
            breadcrumbs: false,
            icon: MdEvent,
            url: '/admin/eventos'
          },
          {
            id: 'usuarios-sistema',
            title: "Usuarios de Sistema",
            type: 'item',
            breadcrumbs: false,
            icon: MdPeople,
            url: '/admin/usuarios-sistema'
          },
          {
            id: 'beneficiarios',
            title: "Beneficiarios",
            type: 'collapse',
            breadcrumbs: false,
            icon: MdFavorite,
            children: [
              // {
              //   id: 'crear-beneficiario',
              //   title: "Crear Beneficiario",
              //   type: 'item',
              //   breadcrumbs: false,
              //   icon: MdPersonAdd,
              //   url: '/admin/beneficiarios/crear-beneficiario'
              // },
              {
                id: 'listado-evento',
                title: "Listado Por Evento",
                type: 'item',
                breadcrumbs: false,
                icon: MdList,
                url: '/admin/beneficiarios/listado-evento'
              },
              {
                id: 'listado-general',
                title: "Listado General",
                type: 'item',
                breadcrumbs: false,
                icon: MdPeople,
                url: '/admin/beneficiarios/listado-general'
              }
            ]
          },
          {
            id: 'directorio-medico',
            title: "Directorio Médico",
            type: 'collapse',
            breadcrumbs: false,
            icon: MdLocalHospital,
            children: [
              {
                id: 'directorio-medico-listado-evento',
                title: "Listado por Evento",
                type: 'item',
                breadcrumbs: false,
                icon: MdEvent,
                url: '/admin/directorio-medico/listado-evento'
              },
              {
                id: 'directorio-medico-directorio',
                title: "Directorio",
                type: 'item',
                breadcrumbs: false,
                icon: MdLocalHospital,
                url: '/admin/directorio-medico/directorio'
              }
            ]
          },
          {
            id: 'voluntarios',
            title: "Voluntarios",
            type: 'collapse',
            breadcrumbs: false,
            icon: MdVolunteerActivism,
            children: [
              {
                id: 'voluntarios-listado-evento',
                title: "Listado por Evento",
                type: 'item',
                breadcrumbs: false,
                icon: MdEvent,
                url: '/admin/voluntarios/listado-evento'
              },
              {
                id: 'voluntarios-listado-general',
                title: "Listado General",
                type: 'item',
                breadcrumbs: false,
                icon: MdList,
                url: '/admin/voluntarios/listado-general'
              }
            ]
          },
          {
            id: 'documentos',
            title: "Documentos",
            type: 'collapse',
            breadcrumbs: false,
            icon: MdDescription,
            children: [
              {
                id: 'consentimiento-beneficiarios',
                title: "Consentimiento Beneficiarios",
                type: 'item',
                breadcrumbs: false,
                icon: MdArticle,
                url: '/admin/documentos/consentimiento-beneficiarios'
              },
              {
                id: 'acuerdo-voluntarios',
                title: "Acuerdo Voluntarios",
                type: 'item',
                breadcrumbs: false,
                icon: MdHandshake,
                url: '/admin/documentos/acuerdo-voluntarios'
              }
            ]
          }
        ]
      }
    ]
  };

export default admin;
